import { UserConnectionCount } from 'shared/model/statistic.model';

type Props = {
  item: UserConnectionCount;
  name: string;
};

const TopUserConnection = ({ item, name }: Props) => {
  return (
    <div className="top-area">
      <div>{name}</div>
      <div>{item.connectionNb}</div>
    </div>
  );
};

export default TopUserConnection;
